import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import PageContainer from 'components/@layout/PageContainer';
import LetterNumberOrder from './LetterNumberOrder';
import LocaleSetting from './Locale';
import GET_GSS_CLASSROOM_SETTINGS from 'graph/settings/gss/get-gss-classroom-settings-query';
import { Classroom } from 'types/schema-generated-types';

interface GssSettingsProps {
  classroom: Classroom;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const ClassroomGssSettings: FC<GssSettingsProps> = ({
  classroom,
  expanded,
  handleChangeExpanded
}) => {
  const { id: classroomId } = classroom;
  const { data, loading } = useQuery(GET_GSS_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: Number(classroomId)
      }
    }
  });

  return (
    <PageContainer loading={loading}>
      <LetterNumberOrder
        panel={'characterOrder'}
        classroom={classroom}
        setting={data?.gssClassroomSettings.characterOrder}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
      <LocaleSetting
        panel={'locale'}
        classroom={classroom}
        setting={data?.gssClassroomSettings.locale}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default ClassroomGssSettings;
